(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54489],{

/***/ 14386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/contactus/modal",
      function () {
        return __webpack_require__(44848);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SpringModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5566);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32692);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39920);









// import { useSpring, animated } from "react-spring/web.cjs"; // web.cjs is required for IE 11 support

var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return {
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            border: "2px solid #000",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3)
        }
    };
});
var Fade = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Fade(props, ref) {
    var open = props.in, children = props.children, onEnter = props.onEnter, onExited = props.onExited, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "in",
        "children",
        "onEnter",
        "onExited"
    ]);
    var style = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
        from: {
            opacity: 0
        },
        to: {
            opacity: open ? 1 : 0
        },
        onStart: function() {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: function() {
            if (!open && onExited) {
                onExited();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: ref,
        style: style
    }, other), {
        children: children
    }));
});
Fade.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().element),
    in: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool.isRequired),
    onEnter: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    onExited: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func)
};
function SpringModal() {
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: handleOpen,
                children: "react-spring"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                "aria-labelledby": "spring-modal-title",
                "aria-describedby": "spring-modal-description",
                className: classes.modal,
                open: open,
                onClose: handleClose,
                closeAfterTransition: true,
                disableScrollLock: true,
                BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                BackdropProps: {
                    timeout: 500
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fade, {
                    in: open,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classes.paper,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                id: "spring-modal-title",
                                children: "Spring modal"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                id: "spring-modal-description",
                                children: "react-spring animates me."
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [76328,49774,92888,40179], function() { return __webpack_exec__(14386); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);